import { Flex, FlexProps, Text } from '@chakra-ui/react';
import { convertPxToRems } from '~/utils-ts';

export const TextCell: React.FC<FlexProps> = ({ children, ...props }) => (
  <Flex alignContent="center" justifyContent="center" {...props}>
    <Text
      as="span"
      color="primary.400"
      fontSize="sm"
      fontWeight="400"
      lineHeight={convertPxToRems(14)}
    >
      {children}
    </Text>
  </Flex>
);
